import { DialogType, TabAndPanelContents, TabListAlignment, TabsProps, TabStyles, TabsWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';
import { ReactModalOptions } from '~commonInfra/dialogs/ReactModalService';
import { Messages } from '~src/codegen/Localize';
import { LinkedTasksDialogWrapper } from '~src/linkedTasks/components/LinkedTasksDialogWrapper';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { FlowBaseInfo } from '~src/ts/models/FlowInfo';
import { RunFlowTaskInfo } from '~src/ts/models/RunFlowTaskInfo';
import { FlowRunTaskDialogContent } from './FlowRunTaskDialogContent';

const dimensionOverrides = {
  tabHeight: 30,
  tabHorizontalPadding: TabStyles.Spacing.LargeSpace,
  tabPanelPadding: '0',
};

const panelHeightClass = style({
  $nest: {
    'div[role=tabpanel]': {
      height: '100%',
    }
  }
});

export function getFlowTaskDialog(flowInfo: FlowBaseInfo, dismiss: () => void, outputId?: string): ReactModalOptions {
  return {
    type: DialogType.NormalWithTitleBar,
    title: Messages.newTask(),
    dialogContent: <FlowTaskDialog flowInfo={flowInfo} dismiss={dismiss} outputId={outputId}/>,
    showCloseButton: true,
    dialogWidth: FeatureFlags.incrementalRefresh ? 900 : 600,
    shouldRecenterOnUpdate: true
  };
}

export function editFlowRunSchedulesDialog(taskInfo: RunFlowTaskInfo, dismiss: () => void): ReactModalOptions {
  return {
    type: DialogType.NormalWithTitleBar,
    title: Messages.editTask(),
    dialogContent: <FlowRunTaskDialogContent taskInfo={taskInfo} dismiss={dismiss}/>,
    showCloseButton: true,
    dialogWidth: FeatureFlags.incrementalRefresh ? 900 : 600,
    shouldRecenterOnUpdate: true
  };
}

export type FlowTaskDialogProps = {
  flowInfo: FlowBaseInfo;
  dismiss: () => void;
  outputId?: string;
}

export function FlowTaskDialog(props: FlowTaskDialogProps): JSX.Element {
  const [tabIndex, setTab] = React.useState(0);

  const tabs: TabAndPanelContents[] = [{
    tabContent: { label: Messages.newTask() },
    panelContent: <FlowRunTaskDialogContent flowInfo={props.flowInfo} dismiss={props.dismiss} singleSelectedOutputId={props.outputId}/>,
  }, {
    tabContent: { label: Messages.linkedTasks() },
    panelContent: <LinkedTasksDialogWrapper {...props}/>,
  }];
  const tabsProps: TabsProps = {
    anchorTabIndex: 0,
    ariaLabel: Messages.tasks(),
    initialActiveIndex: 0,
    onActiveIndexChanged: setTab,
    tabListAlignment: TabListAlignment.Left,
    tabs: tabs,
    testId: 'flowTaskDialogId',
    dimensionOverrides
  };
  return <TabsWidget {...tabsProps} className={panelHeightClass}/>;
}
